import React from "react";
import BounceLoader from "react-spinners/SyncLoader";

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "#0078ff",
  top: "50%",
  left: "50%",
  position: "fixed",
  color: "darkred",
  marginTop: "-32px",
  marginLeft: "-32px",
  transform: "translate(-50%, -50%)",
};


const Index = () => {
  return (
    <div className="loader">
      <BounceLoader cssOverride={override} color={"#0078ff"} loading={true} />
    </div>
  );
};

export default Index;
